<template>
	<div>

		<el-drawer :visible.sync="isshow" :with-header="false" :before-close="handleClose" :modal="false">

			<div class="detailArea" v-loading="loading">

				<!--  -->
				<div class="detail-head FlexBetween outerpadd">
					<div class="head_left Flexalign">
						<div class="pup_title">
							{{ptitle}}
						</div>
						<div class="detail_links Flexalign">
							<div class="icon">
								<img src="../../image/icon1.png" alt="" v-if="types == 1">
								<img src="../../image/icon2.png" alt="" v-else-if="types == 2">
								<img src="../../image/icon3.png" alt="" v-else-if="types == 3">
								<img src="../../image/icon4.png" alt="" v-else-if="types == 4">
							</div>
							<div class="links_txt FlexRow">
								{{code_val}}
							</div>
						</div>

						<div class="detail_selChange Flexalign">
							<div class="sel_item Flexalign">
								<el-select v-model="screVal1" @change="setChanges">
									<el-option v-for="item in statuslist" :label="item.name" :value="item.id">
										{{ item.name }}
									</el-option>
								</el-select>
							</div>
						</div>

					</div>
					
					
					<div class="head_right Flexalign" v-show="is_recycle == 1" >
						<el-tooltip content="恢复" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit" @click="head_btnClick(4)"></el-button>
						</el-tooltip>
						<el-tooltip content="彻底删除" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-suitcase" @click="head_btnClick(5)"></el-button>
						</el-tooltip>
						<el-tooltip content="编辑" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit-outline"
								@click="head_btnClick(3)"></el-button>
						</el-tooltip>
					</div>
					<div class="head_right Flexalign" v-show="is_recycle == 0">
						<el-tooltip content="编辑" placement="bottom" effect="light">
							<el-button class="drawer_btn" icon="el-icon-edit-outline" @click="head_btnClick(3)"></el-button>
						</el-tooltip>
						<el-dropdown>
							<el-button type="text" class="drawer_btn-more" icon="el-icon-more" style="margin: 0;">
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="2"  @click.native="switchState(1)" v-if="types != 4">
									设置父{{typelist[types - 1] || '工作项'}}
								</el-dropdown-item>
								<el-dropdown-item :command="2"  @click.native="switchState(2)">
									删除
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
									
					
					
					
				</div>
				<!--  -->
				<!--  -->
				<div class="detail-top ">
					<!--  -->
					<template v-if="types != 4 && drawer_info">
						<parentarea :parentinfo="drawer_info"  :isfather.sync="head_father"
						@update="fn_update"  :content_id="content_id" ref="titleparent"
						:types="parentTpe"
						></parentarea>
					</template>
					<!--  -->
					<!--  -->
					<div class="isfatherArea Flexalign ">
						<div class="title_txt Flexalign">
							<div class="father_icon" v-if="head_father">
								<i class="iconfont icon-a-juxing19"></i>
							</div>
							<div class="tit" v-show="!ischange">
								{{ drawer_info_title }} 
							</div>
						</div>
						<div class="title_change" v-show="ischange">
							<el-input ref="saveTagInput" v-model="drawer_info_title" @blur="titleBlur"></el-input>
						</div>
						<div class="change_btn" v-show="!ischange" @click="titleChnage">
							<i class="iconfont icon-a-bingji1"></i>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="det_topinfo Flexalign">
						<div class="mem_txt" v-if="drawer_info.member_name">
							{{ drawer_info.member_name || "" }}
						</div>
						<div class="mem_txt" v-else-if="drawer_info.member">
							{{ drawer_info.member.name || "" }}
						</div>
						<div class="txts">
							创建于{{ drawer_info.create_time || "" }},
							{{ drawer_info.update_time ? '最近更新于'+ drawer_info.update_time : '暂无更新'}}
						</div>
					</div>
					<!--  -->
				</div>
				<!--  -->
				<!--  style="overflow: auto;" :style="{ height: windowHeight - 200 + 'px' }" -->
				<div class="detail_content " >
					<div class="container_tabs outerpadd">
						<!--  -->
						<el-tabs class="eltabs" v-model="activeName">
							<el-tab-pane label="信息" name="1">

								<div class="eltabs_info FlexWrap">
									<template v-for="(item,index) in stablelist2">
										<template v-if="item.field_type != 19">
											<div class="eltabs_item Flexalign" >
												<div class="eltabs_label">{{ item.field }}</div>
												<div class="eltabs_text Flexalign">
													<div class="member_area FlexRow" v-if="item.character">
														<i class="iconfont icon-a-lujing131"></i>
													</div>
													<div class="txt Singlerow">
														{{ item.select_field || "暂无" }}
													</div>
												</div>
											</div>
										</template>
										<div class="Richarea" v-else>
											<div class="Richtit">
												{{item.field || ''}}
											</div>
											<div  v-html="item.select_field">
											</div>
										</div>
									</template>
								</div>

							</el-tab-pane>
							<el-tab-pane label="详细" name="2">
								<detailsdisplay :classlist="curClass_list" :fieldlist="curField_list">
								</detailsdisplay>
							</el-tab-pane>
							
							
							<template v-if="types == 1">
								<el-tab-pane label="子需求" name="3">
									<workitems :isshow="activeName == '3'" :memberlist="memberlist" :content_id="content_id"
									 :project_id="drawer_info.project_id" :infos="drawer_info"
										:currentRote="1"></workitems>
								</el-tab-pane>
							</template>
							
							<template v-if="types == 1 || types == 2 || types == 3">
								<el-tab-pane label="子任务" name="4">
									<workitems :isshow="activeName == '4'" :memberlist="memberlist" :content_id="content_id"
									 :project_id="drawer_info.project_id" :infos="drawer_info"
										:currentRote="2"></workitems>
								</el-tab-pane>
							</template>
							
							<template v-if="types == 3">
								<el-tab-pane label="子问题" name="5">
									<workitems :isshow="activeName == '5'" :memberlist="memberlist" :content_id="content_id"
								 :project_id="drawer_info.project_id" :infos="drawer_info"
										:currentRote="3"></workitems>
								</el-tab-pane>
							</template>
							
							
							<el-tab-pane label="关联需求" name="6" v-if="types == 1">
								<assocarea :types="2" :isshow="activeName == '6'" :memberlist="memberlist" :content_id="content_id" :project_id="drawer_info.project_id"
									:infos="drawer_info"
									:currentRote="1"></assocarea>
							</el-tab-pane>
							<el-tab-pane label="关联任务" name="7" v-if="types == 1 || types == 3">
								<assocarea :isshow="activeName == '7'" :memberlist="memberlist" :content_id="content_id" :project_id="drawer_info.project_id"
									:infos="drawer_info"
									:currentRote="2"></assocarea>
							</el-tab-pane>
							<el-tab-pane label="关联问题" name="8" v-if="types == 3">
								<assocarea :isshow="activeName == '8'" :memberlist="memberlist" :content_id="content_id" :project_id="drawer_info.project_id"
								:infos="drawer_info"
									:currentRote="3"></assocarea>
							</el-tab-pane>
							
							<template v-if="types == 4">
								<el-tab-pane label="关联需求" name="6">
									<assocarea :isshow="activeName == '6'" :memberlist="memberlist" :content_id="content_id" :project_id="content_id"
										:infos="drawer_info"
										:currentRote="1"></assocarea>
								</el-tab-pane>
								<el-tab-pane label="关联任务" name="7">
									<assocarea :isshow="activeName == '7'" :memberlist="memberlist" :content_id="content_id" :project_id="content_id"
										:infos="drawer_info"
										:currentRote="2"></assocarea>
								</el-tab-pane>
								<el-tab-pane label="关联问题" name="8">
									<assocarea :isshow="activeName == '8'" :memberlist="memberlist" :content_id="content_id" :project_id="content_id"
									:infos="drawer_info"
										:currentRote="3"></assocarea>
								</el-tab-pane>
							</template>
							
							
							

						</el-tabs>
						<!--  -->
					</div>

					<!--  -->
					<div class="content-container_bottom">
						<div class="container_bottom_tabs">
							<el-tabs class="bottom_eltabs" v-model="activeLog">
								
								<el-tab-pane  name="5">
									<operationlog :show="islogshow" :types="content_type" :content_id="content_id"
									@retnum="(e)=> operalog_num = e">
									</operationlog>
									<!--  -->
									<template slot="label">
										<div class="b_navItem FlexRow" :class="{'isActive': activeLog == '5'}">
											<span>
												操作日志
											</span>
											<div class="num_box" v-if="operalog_num">
												{{operalog_num}}
											</div>
										</div>
									</template>
									<!--  -->
								</el-tab-pane>
								<el-tab-pane>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
					<!--  -->

				</div>
				<!--  -->
			
			</div>
			
			<div class="pupclose FlexColumn" @click="handleClose">
				<i class="el-icon-arrow-right"></i>
			</div>

		</el-drawer>

	</div>
</template>

<script>
	var that;
	import VueUeditorWrap from "vue-ueditor-wrap";
	import {
		JudgmentRequ,
		fn_retjson,
		retJSONArr,
	} from "network/defaults";

	import detailsdisplay from "../../components/newpup/detailsdisplay.vue"
	import operationlog from "@/components/tabledata/operationlog.vue";
	
	import parentarea from "../../components/association/parentarea.vue"
	// 子级
	import workitems from "../../components/newpup/workitems.vue"
	// 关联
	import assocarea from "../../components/newpup/assocarea.vue"
	
	
	import {

		del_project_damand,
		update_project_damand_field,
		updata_project_field,
	} from "../../js/project.js";

	import {
		xmde_del,
		recycle_project,
	} from "network/hk_operset";


	import {
		timestampToTime,
	} from "network/kh_public";


	export default {
		name: "detailspup",
		components: {
			VueUeditorWrap,
			detailsdisplay,
			operationlog,
			workitems,
			assocarea,
			parentarea,
		
		},
		props: {
			
			ptitle: {
				type: String,
				default: '',
			},
			dinfo: {
				type: String,
				default: '',
			},
			is_recycle: {
				type: Number,
				default: 0,
			},


			stablelist: {
				type: Array,
				default: () => {
					return []
				},
			},
			statuslist: {
				type: Array,
				default: () => {
					return []
				},
			},

			types: { // 1.项目需求  2.项目任务  3.项目问题  4.项目列表
				type: Number,
				default: 1,
			},
			

			//
			classlist: {
				type: Array,
				default: () => {
					return [];
				},
			},
			fieldlist: {
				type: Array,
				default: () => {
					return [];
				},
			},

			memberlist: {
				type: Array,
				default: () => {
					return [];
				},
			},

			content_id: {
				type: Number,
				default: 0,
			},


			isshow: {
				type: Boolean,
				default: false,
			},
			// 基础数据 是否加载完成
			loading: {
				type: Boolean,
				default: true,
			},


		},

		data() {
			return {
				operalog_num: 0,
				
				head_father: false,
				ischange: false,
				
				typelist: [
					'需求','任务','问题',
				],


				screVal1: 1,
				drawer_info: '',
				activeName: '1',

				activeLog: "5",

				windowHeight: window.innerHeight,

				curClass_list: [],
				curField_list: [],

				stablelist2: [],

				content_type: 0,
				islogshow: false,
				code_val: '',
				
				currentTitle: '',
				currentStauts: '',
				drawer_info_title: '',
				
				parentTpe: '1',

			};
		},
		created() {
			that = this;
			this.islogshow = false
		},
		watch: {
			isshow() {
				this.operalog_num = 0
				this.activeName = '1'
				this.islogshow = false
				if (this.isshow) {
					this.setDatas()
				} else {
					this.drawer_info = ''

				}
			},
			dinfo() {
				this.islogshow = false
				if (this.dinfo) {
				
					this.setDatas()
				} else {
					this.drawer_info = ''

				}

			},
			fieldlist(){
				let newArr1 = this.headledata(this.fieldlist)
				this.curField_list = fn_retjson(newArr1)
				
				let newArr2 = this.headledata(this.stablelist)
				this.stablelist2 = fn_retjson(newArr2)
			},
		},
		methods: {
			// 修改父级后刷新
			fn_update(){
				this.curClass_list = []
				this.curField_list = []
				this.$emit('update')
			},
			// 修改标题
			titleBlur() {
				let val = (this.drawer_info_title + '').trim()
				if (val) {
					if(this.currentTitle != val) {
						
						let fd = new FormData();
						if(this.types == 4) {
							fd.append('field', 'name');
						}
						else {
							fd.append('field', 'title');
						}
						fd.append('value', val);
						fd.append('member_id', this.drawer_info.member_id);
						let edit_data = []
						let newEle = {
							field: '标题', // 字段名称
							before: this.currentTitle,  //修改前
							after: val, //修改后
						}
						edit_data.push(newEle)
						fd.append('edit_data', JSON.stringify(edit_data));
						this.update_projectfield(fd)
					}
					this.ischange = false
				} 
				else {
					this.$alertMess('标题不能为空', 'error')
				}
			},
			titleChnage() {
				if (this.$refs.saveTagInput) {
					this.ischange = true
					this.$nextTick(() => this.$refs.saveTagInput.focus());
				}
			},
			// 修改状态
			setChanges() {
				let fd = new FormData();
				fd.append('field', 'status');
				fd.append('value', this.screVal1);
				fd.append('member_id', this.drawer_info.member_id);
				let edit_data = []
				let newEle = {
					field: '状态', // 字段名称
					before: this.currentStauts,  //修改前
					after: '', //修改后
				}
				let index1 = this.statuslist.findIndex(v=>v.id == this.screVal1)
				if(index1 != -1) {
					newEle.after = this.statuslist[index1].name || ''
				}
				edit_data.push(newEle)
				fd.append('edit_data', JSON.stringify(edit_data));
				this.update_projectfield(fd)
			},
			update_projectfield(fd){
				if(this.types == 4) {   // 项目列表
					fd.append('project_id', this.drawer_info.project_id);
					updata_project_field(fd).then((res)=>{
						if (this.$handlereq(res)) {
							this.$alertMess('更新成功')
							this.fn_update()
						}
					})
				}
				else {  // 项目需求、任务、问题
					fd.append('project_demand_id', this.drawer_info.project_demand_id);
					update_project_damand_field(fd).then((res)=>{
						if (this.$handlereq(res)) {
							this.$alertMess('更新成功')
							this.fn_update()
						}
					})
				}
			},
			headledata(arr) {
				if (arr.length) {
					for (let item of arr) {
						item.disabled = true
						let field_type = item.field_type
						let field = item.field || item.field_sign;
						if (field_type == 3 && item.select_field) { // 时间字段 memberlist
							item.select_field = timestampToTime(item.select_field, true)
						}
						if (field == '协同人') {
							if (this.memberlist.length && item.content.length) {
								let res_arr = []
								for (let val of item.content) {
									let arr1 = this.memberlist.filter(v => v.member_id == val)
									let name = arr1[0] ? arr1[0].name : '';
									res_arr.push(name)
								}
								item.select_field = res_arr.length ? res_arr.join('、') : '';

							} else {
								item.select_field = ''
							}
						}
					}
				}
				return arr
			},
			setDatas() {
			
				let res = retJSONArr(this.dinfo)
				this.drawer_info = fn_retjson(res)
				this.drawer_info_title = this.drawer_info.title || this.drawer_info.name;
				this.islogshow = false
				if (this.types == 4) { // 7:项目
					this.content_type = 7
					this.code_val = this.drawer_info.xm_code
					this.screVal1 = this.drawer_info.status
				} else if (this.types < 4) { // 12项目需求，13项目任务，14项目问题
					let n = 11
					this.content_type = n + this.types
					this.code_val = this.drawer_info.project_demand_code
					this.screVal1 = this.drawer_info.status
				}
				this.currentTitle = JSON.parse(JSON.stringify(this.drawer_info_title))
				let index1 = this.statuslist.findIndex(v=>v.id == this.drawer_info.status)
				if(index1 != -1) {
					this.currentStauts = this.statuslist[index1].name || ''
				}
				setTimeout(() => {
					this.islogshow = true
				}, 350)


				this.curClass_list = fn_retjson(this.classlist)

				

				
				if(this.types != 4) {
				
					let pid_result = this.drawer_info.project_demand_pid_result
					this.head_father = pid_result ? true : false;
					if(this.types == 1) {
						this.parentTpe = '1'
					}
					else if(this.types == 2) {
						this.parentTpe = '1,2'
					}
					else if(this.types == 3) {
						this.parentTpe = '3'
					}
					
						
				}
				
				
				
				


			},
			handleClose() {
				this.$emit("update:isshow", false);
			},

			head_btnClick(flag) {
				if (flag == 3) { // 编辑
					this.$emit('editdatas')
				} else if (flag == 4) { // 恢复
					this.restore_project()
				} else if (flag == 5) { // 彻底删除
					if (this.types == 4) {
						this.cddel_business()
					}
				}
			},

			switchState(flag) {
				if (flag == 1) {
					if(this.$refs.titleparent) {
						this.$refs.titleparent.isEdit = true
						this.head_father = true
					}
				}
				else if (flag == 2) {
					if (this.types < 4) {
						let data = {
							project_demand_id: this.drawer_info.project_demand_id,
							type: this.types,
						}
						this.release_dele(data)
					} else if (this.types == 4) {
						this.release_gh()
					}
				}
			},

			// 删除
			release_dele(data) {
				this.$confirm("您确定要删除吗?")
					.then(() => {
						del_project_damand(data).then((res) => {
							if (this.$handlereq(res)) {
								this.$alertMess("删除成功", "success");
								this.$emit('delesucc')
							}
						});
					})
					.catch(() => {});
			},

			// 回收站 彻底删除
			cddel_business() {
				this.$confirm("您确定要删除吗?")
					.then(() => {
						xmde_del(this.drawer_info.project_id).then((res) => {
							if (this.$handlereq(res)) {
								this.$alertMess("删除成功", "success");
								this.$emit('delesucc')
							}
						});
					})
					.catch(() => {});
			},
			// 项目列表数据 加入回收站
			release_gh() {
				this.$confirm("您确定要删除吗?")
					.then(() => {
						recycle_project(this.drawer_info.project_id, 1).then((res) => {
							if (this.$handlereq(res)) {
								this.$emit('delesucc')
								this.$alertMess("删除成功", "success");
							}
						});
					})
					.catch(() => {});
			},

			// 恢复 项目列表数据
			restore_project() {
				recycle_project(this.drawer_info.project_id, 0).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("恢复成功", "success");
						this.$emit('delesucc')
					}
				});
			},




		},
	};
</script>



<style scoped lang="scss">
	@import "../../css/projecticon.css";
	@import "@/assets/css/project/dpup.scss";
</style>